import angular from 'angular';
import { applyNsjTableInlineMobileLabels, buildNsjTableInlineMobileLabel } from '../../../../utils/nsj-table';
import { IUploadDocumentoListItem } from '../models/upload-documentos-em-lote.service.model';
import { UploadDocumentosEmLoteService } from '../upload-documentos-em-lote.service';

export class UploadDocumentosEmLoteIndexController {

    static $inject = [
        '$rootScope',
        '$scope',
        '$state',
        'UploadDocumentosEmLoteService',
    ];

    public busy = false;
    public entities: IUploadDocumentoListItem[] = [];

    public fields = applyNsjTableInlineMobileLabels([
        {
            value: 'created_at',
            label: 'Data de criação',
            type: 'date',
            style: 'title',
            copy: '',
            customCollumnHtml: () => `
                <span ng-bind="tableRowEntity.created_at | asDate | date: 'dd/MM/yyyy'"></span> às
                <span ng-bind="tableRowEntity.created_at | asDateTime | date: 'HH:mm'"></span>
            `,
        },
        {
            value: 'created_by.nome',
            label: 'Criado por',
            type: 'string',
            style: 'title',
            copy: '',
        },
        {
            value: 'tipoarquivo_titulo',
            label: 'Tipo de documento',
            type: 'string',
            style: 'title',
            copy: '',
        },
        {
            value: 'nome',
            label: 'Documento',
            type: 'string',
            style: 'title',
            copy: '',
        },
        {
            value: 'competenciaano',
            label: 'Competência',
            type: 'string',
            style: 'title',
            copy: '',
            customCollumnHtml: () => `
                <span ng-if="tableRowEntity.competenciaano">
                    {{tableRowEntity.competenciames | mesEnum}}/{{tableRowEntity.competenciaano}}
                </span>
                <span ng-if="!tableRowEntity.competenciaano" class="text-muted">—</span>
            `,
        },
        {
            value: 'qtd_colaboradores',
            label: 'Colaboradores',
            type: 'string',
            style: 'title',
            copy: '',
        },
        {
            value: 'status',
            label: 'Situação',
            type: 'string',
            style: 'title',
            copy: '',
            customCollumnHtml: () => `
                <label class="label {{tableRowEntity.status | situacaoUploadDocumentosLoteClassEnum}}">
                    {{tableRowEntity.status | situacaoUploadDocumentosLoteEnum:tableRowEntity.statusreversao}}
                </label>
            `,
        },
        {
            value: 'uploaddocumento',
            label: 'Ações',
            type: 'div',
            style: 'title',
            copy: '',
            customLabelHtml: buildNsjTableInlineMobileLabel('Ações', { showOnMobile: false }),
            customCollumnScope: {
                visualizarLote: (entity: IUploadDocumentoListItem) => {
                    this.busy = true;
                    this.$state.go('uploaddocumentoslote_show', {
                        uploaddocumento: entity.uploaddocumento
                    // transição rejeitada devolve a listagem ao estado normal; no
                    // sucesso o controller já foi destruído.
                    }).catch(() => this.busy = false);
                },
            },
            customCollumnHtml: () => `
                <div class="display-flex justify-content-end-md">
                    <a
                        class="btn btn-tertiary btn-sm"
                        ng-click="customCollumnScope.visualizarLote(tableRowEntity)"
                    >
                        Ver detalhes
                    </a>
                </div>
            `,
        }
    ]);

    constructor(
        public $rootScope: angular.IRootScopeService,
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public UploadDocumentosEmLoteService: UploadDocumentosEmLoteService,
    ) {
        this.refresh();

        $scope.$on('meurh_uploadsdocumentos_index_finished', (_event, args: IUploadDocumentoListItem[]) => {
            this.entities = args;
        });
    }

    refresh(): void {
        this.entities = [];
        this.UploadDocumentosEmLoteService.reload();
    }

    verMais(): void {
        this.UploadDocumentosEmLoteService.loadMore();
    }

    temMais(): boolean {
        return !this.UploadDocumentosEmLoteService.loadParams.finished;
    }
}
